import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lectionary-year-edit',
  templateUrl: './lectionary-year-edit.component.html',
  styleUrls: ['./lectionary-year-edit.component.css']
})
export class LectionaryYearEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
